import React from "react";
import BlogSearch from "./BlogSearch";
import BlogCategoryList from "./BlogCategoryList";
import RecentBlogs from "./RecentBlogs";

const BlogSidebar = ({setQuery}) => {
  return (
    <aside>
      <BlogSearch setQuery={setQuery} />
      <div className="gap-30" />
      <BlogCategoryList
        title={"Categories"}
        blogCategories={["Instabuild", "Building Materials", "Build x Tech", "Construct x Innovate"]}
      />
      <div className="gap-30" />
      {/* <BlogTags
        blogTagsList={["Categories", "Categories", "Categories", "Cat", "Dpgs"]}
      /> */}
      <div className="gap-30" />
      <RecentBlogs />
    </aside>
  );
};

export default BlogSidebar;
